import { render, staticRenderFns } from "./CBT.vue?vue&type=template&id=25ecabe8&"
import script from "./CBT.vue?vue&type=script&lang=js&"
export * from "./CBT.vue?vue&type=script&lang=js&"
import style0 from "./CBT.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports